import Decimal from 'decimal.js';

Decimal.set({
  rounding: 7,
});

export const createDecimal = (value: number | string | Decimal): Decimal => {
  let valueToUse = typeof value === 'string' ? value.replace(/,/g, '') : value;
  valueToUse = valueToUse === '' ? 0 : valueToUse;

  return new Decimal(valueToUse || 0);
};

/**
 * Safe wrapper for form input values that may be intermediate typing states
 * like "-", ".", or "-." which are valid prefixes but not valid Decimal values.
 */
export const safeDecimal = (value: string | number | undefined | null): Decimal => {
  try {
    return createDecimal(value ?? 0);
  } catch {
    return createDecimal(0);
  }
};
